import { unsavedChangesGuard } from '../../../../shared/guards/unsaved-changes.guard';

export type { LeaveConfirmable } from '../../../../shared/guards/unsaved-changes.guard';

/**
 * Sair do editor de anúncio com edição não salva pergunta antes (o clique no menu jogava fora o
 * preço e a ficha digitados). É o guard do shared, com o nome de sempre para as rotas do anúncio.
 * Arquivo próprio, sem importar o componente: a rota carrega o editor sob demanda.
 */
export const advertisementLeaveGuard = unsavedChangesGuard;
